<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @import "../common/style/variables";
    .go-register {
        padding-top: 38px * @scaleRate;
        font-size: 12px;
        color: #4B89F3;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 22px * @scaleRate;
            margin-left: 11px * @scaleRate;
        }
    }
    .login {
        height: 100%;
        background-image: url("../common/image/bg_new@2x.png");
        background-size: cover;
        background-position: center;
        position: relative;
        &-con {
            position: absolute;
            top: 177px *@scaleRate;
            right: 255px *@scaleRate;
/*
            transform: translate(-50%, -50%);
*/
            width: 541px * @scaleRate;
            height: 600px * @scaleRate;
            text-align: center;
            background: #ffffff;
            box-shadow: 2px 2px 27px -7px #9BC2FE;
            border-radius: 10px;
            .tab{
                width: 100%;
                display: flex;
                height: 75px *@scaleRate;
                font-size: 25px *@scaleRate;
                color: #111111;
                letter-spacing: 0;
                div{
                    width: 50%;
                    text-align: center;
                    height:100%;
                    line-height: 75px *@scaleRate;
                    cursor: pointer;
                }
            }
            .tab-selected-left{
                background: #F0F2F4;
                border-radius: 10px 0 0 0;
            }
            .tab-selected-right{
                background: #F0F2F4;
                border-radius: 0 10px 0 0;
            }
            .login-wx {
                padding-top: 103px * @scaleRate;
                position: relative;
                height: 100%;
                font-size: 16px;
            }
            .login-org {
                position: relative;
                height: 100%;
                font-size: 16px;
                padding-top: 103px * @scaleRate;
                &-cont {
                    width: 337px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -70%);
                }
                &-header {
                    color: #4b89f3;
                    font-size: 27px;
                    margin-bottom: 18px;
                    text-align: center;
                    font-weight: bold;
                }
            }
            .org-apply{
                height: 393.75px ;
                position: absolute;
                width: 100%;
                background: #ffffff;
                left: 0;
                bottom: 0;
                z-index: 1;
                padding-top: 114px  * @scaleRate;
                img{
                    height: 250px * @scaleRate;
                    width: 250px * @scaleRate;
                    display: block;
                    margin:0 auto ;
                }
                .stop-apply{
                    position: absolute;
                    right: 25px * @scaleRate;
                    bottom: 21px * @scaleRate;
                    cursor: pointer;
                    font-size: 13px;
                    color: #4B89F3;
                    i{
                        background: url("../common/image/icon_right_blue_arrow.png") no-repeat;
                        background-size: cover;
                        width: 9px;
                        height: 9px;
                        display: inline-block;
                        margin-right: 3px;
                        transform:rotate(180deg);
                        -ms-transform:rotate(180deg); /* IE 9 */
                        -webkit-transform:rotate(180deg); /* Safari and Chrome */
                    }
                }
                .org-apply-prompt{
                    padding-top: 35px * @scaleRate;
                    div:nth-of-type(1){
                        font-size: 20px * @scaleRate;
                        color: #111111;
                        letter-spacing: 0;
                    }
                    div:nth-of-type(2){
                        font-size: 20px * @scaleRate;
                        color: #000000;
                        letter-spacing: 0;
                        text-align: center;
                        line-height: 28px * @scaleRate;
                    }
                }
            }
        }
        &-logo {
            width: 100px;
            height: 44px;
        }
        &-qc {
            width: 250px;
            height: 250px;
            margin: 20px 0;
        }
        &-tip {
            font-size: 13px;
            color: #8e8e93;
            line-height: 18px;
        }
        &-success {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, .5);
        }
        .scan-success {
            position: absolute;
            top: 40%;
            width: 100%;
            text-align: center;
            &-text {
                font-size: 30px;
                color: #fff;
                height: 42px;
                line-height: 42px;
            }
            &-desc {
                margin-top: 13px;
                line-height: 32px;
                color: #fff;
                font-size: 24px;
            }
        }
        .btn-orz{
            position: absolute;
            bottom: 10px;
            right: 39px * @scaleRate;
            color: #111111;
            height: 69.5px * @scaleRate;
            cursor: pointer;
            font-size: 13px;
            color: #4B89F3;
            letter-spacing: 0;
            .arrow{
                background: url("../common/image/icon_right_blue_arrow.png") no-repeat;
                background-size: cover;
                width: 9px;
                height: 9px;
                display: inline-block;
                margin-left: -3px;
            }
        }
    }
    .impowerBox .qrcode {
        width: 150px * @scaleRate;
        margin-top: 15px;
        border: 1px solid #E2E2E2;
    }

    .mask {
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .verify-title {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        border-bottom: 1px solid #dfdfdf;
        box-sizing: border-box;
        font-size: 16px;
        .left {
            flex: 1;
        }
        .right {
            color: #409EFF;
            cursor: pointer;
        }
    }

    .slide{
        width: 340px;
        margin: 0 auto;
        position: relative;
        background: #ffffff;
        .agin{
            width: 30px;
            height: 30px;
            background: url(../common/image/icon_light.f13cff3.png) 0 -437px;
            position: absolute;
            right: 25px;
            top: 65px;
            &:hover{
                cursor: pointer;
                background: url(../common/image/icon_light.f13cff3.png) 0 -872px;
            }
        }
    }
    .box {
        width: 300px;
        padding: 20px;
        background-color: #ffffff;
        position: relative;
    }

    .imgBox {
        position: relative;
        width: 300px;
        overflow: hidden;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.4);
    }

    .imgBox img {
        width: 100%;
        vertical-align: middle;
    }

    .handle {
        width: 300px;
        display: flex;
        align-items: center;
        position: relative;
        height: 38px;
        margin: 20px 0;
        padding: 4px 0 4px 0;
        background: #f7f9fa;
        border: 1px solid #e4e7eb;
        box-sizing: border-box;
        user-select: none;
        .changeBorder{
            position: absolute;
            top:0;
            left: 0;
            width: 20px;
            height: 20px;
            border: 1px solid #409EFF;
        }
    }

    .text {
        opacity: 1;
        transition: opacity 0.5s ease-in-out;
        margin-left: 86px;
    }

    .swiper {
        position: absolute;
        left: 0;
        width: 38px;
        height: 38px;
        background-color: #ffffff;
        box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.2);
        &:hover{
            background: #409EFF;
            cursor: pointer;
            .imgBk{
                background: url(../common/image/icon_light.f13cff3.png) 0 -12px;
            }
        }
        .imgBk{
            display: inline-block;
            width: 14px;
            height: 12px;
            margin-top: 14px;
            background: url(../common/image/icon_light.f13cff3.png) 0 -26px;
        }
    }

    .verify {
        position: absolute;
        left: 10px;
        width: 40px;
        height: 48px;
        border-radius: 5px;
        background-repeat: no-repeat;
        background-attachment: scroll;
        background-size: 300px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4), 0 0 10px 0 rgba(90, 90, 90, 0.4);
        z-index: 10;
        img {
            vertical-align: middle;
        }
    }
</style>

<style lang="less">
    .ivu-modal {
        top: 50%!important;
        transform: translateY(-50%)!important;
    }
    .login-cont {
        input {
            background-color: rgba(255, 255, 255, 0.5) !important;
            font-size: 16px;
            padding: 4px 7px;
            height: 34px;
        }
        button {
            font-size: 16px;
        }
    }

</style>
<template>
    <div class="login" style="position: relative;">
        <div class="login-con">

            <div class="tab">
                <div @click="tabSelect(true)" :class="{'tab-selected-left':!isExperts}">专家登录</div>
                <div @click="tabSelect(false)" :class="{'tab-selected-right':isExperts}">机构登录</div>
            </div>
            <!--微信登录-->
            <div id="login-wx" class="login-wx" v-show="isExperts">
                <Form ref="login-experts" :model="loginExpert" :rules="ruleLoginExpert">
                    <Form-Item prop="phone" :error="loginError">
                        <Input v-model="loginExpert.phone" placeholder="手机号"/>
                    </Form-Item>
                    <Form-Item  prop="password">
                        <Input type="password" v-model="loginExpert.password" placeholder="请输入密码"/>
                    </Form-Item>
                    <Form-Item class="forget">
                        <div style="color: #4b89f3;line-height: 21px; cursor: pointer; width: 100%; text-align: right;"><span @click="$router.push('/forgetPwd')">找回密码</span></div>
                    </Form-Item>
                    <FormItem id="goLogin">
                        <Button type="primary" long @click="loginExp('login-experts')">登录</Button>
                    </FormItem>
                    <div class="go-register" @click="$router.push('/register')">
                        <p>去注册</p>
                        <img src="../common/image/arrow_icon.png" alt="">
                    </div>
                </Form>
            </div>
            <!--机构登录-->
            <div class="login-org"  v-show="!isExperts">
                <Form ref="login-fake" :model="loginUser" :rules="ruleLogin">
                    <Form-Item prop="username" :error="loginError">
                        <Input v-model="loginUser.username" placeholder="用户名"/>
                    </Form-Item>
                    <Form-Item  prop="password">
                        <Input type="password" v-model="loginUser.password" placeholder="请输入密码"/>
                    </Form-Item>
                    <Form-Item class="forget" prop="isRemember">
                        <Checkbox v-model="loginUser.isRemember"><span style="color: #4b89f3;">记住密码</span></Checkbox>
                        <span style="color: #4b89f3;position: absolute;right: 0; cursor: pointer" @click="isOrg=!isOrg">申请机构入驻</span>
                    </Form-Item>
                    <FormItem id="goLogin">
                        <Button type="primary" long @click="loginIn('login-fake')">登录</Button>
                    </FormItem>
                </Form>
            </div>
            <!--机构申请-->
            <div class="org-apply" v-show="isOrg">
                <img src="../common/image/icon_org_apply.jpg"/>
                <div class="org-apply-prompt">
                    <div>机构入驻申请</div>
                    <div>请用微信二维码，添加运营专员申请</div>
                </div>
                <div class="stop-apply" @click="isOrg=!isOrg">
                    <i></i><span>返回</span>
                </div>
            </div>
            <!--专家找回密码-->
            <div class="org-apply" v-show="isExp">
                <!-- 测试 -->
                <!-- <img src="../common/image/icon_exp_apply_test.png"/> -->
                <!-- 正式 -->
                <img src="../common/image/qrcode_prod.png"/>
                <div class="org-apply-prompt">
                    <div>专家找回密码</div>
                    <div>请用微信二维码，找回您的密码</div>
                </div>
                <div class="stop-apply" @click="isExp=!isExp">
                    <i></i><span>返回</span>
                </div>
            </div>
        </div>

        <div class="mask" v-if="codeBoll">
            <div class="slide">
                <div class="verify-title">
                    <div class="left">请完成拼图验证</div>
                    <div class="right" @click='codeBoll = false'>关闭</div>
                </div>
                <div id="container">
                    <div class="box" ref='box' @mouseup='boxUp'>
                        <div class="imgBox" :style='{width: imgBoxW, height: imgBoxH}'>
                            <img class='verImg' :src="gL.imgReq" :style='{width: imgBoxW, height: imgBoxH}'/>
                            <div class="verify" ref='verify' :style='{width: newImageW, height: newImageH, top: newImageT, left: newImageL}'>
                                <img class='xiaotu' :src="gL.newImage" :style='{width: newImageW, height: newImageH}'/>
                            </div>
                        </div>
                        <div class="handle" ref='handle'>
                            <div class="changeBorder" :style='{width: changeBorderW, height: changeBorderH, background: changeBorderB}'></div>
                            <span class="swiper" ref='swiper' :style='{left: swiperL}' @mousedown='swiperMove($event)'>
								<span class="imgBk"></span>
							</span>
                            <span class="text" :style='{opacity: textO}'>向右滑动填充拼图</span>
                        </div>
                    </div>
                </div>
                <div class="agin" @click='getCaptcha'>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
  export default {
    data () {
      return {
        loginId: '',
        qrCode: 'http://iph.href.lu/250x250',
        socket: null,
        status: '',
        isExperts:true,
        isOrg:false,
        isExp:false,
        //   机构登录
          loginUser: {
              username: '',
              password: '',
              isRemember: false
          },
        //   专家登录
          loginExpert: {
              phone: '',
              password: ''
          },
          ruleLogin: {
              username: [
                  {required: true, message: '请输入用户名'}
              ],
              password: [
                  {required: true, message: '请输入密码'}
              ]
          },
          ruleLoginExpert: {
              phone: [
                  {required: true, message: '请输入手机号'},
                  {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, max: 11, message: '请输入正确的手机号', trigger: 'change' }
              ],
              password: [
                  {required: true, message: '请输入密码'}
              ]
          },
          loginError: '',

          codeBoll: false, // 滑动验证弹窗是否展示
          imgBoxW: '300px', // 拼图底图的宽
          imgBoxH: '', // 拼图底图的高
          newImageT: '', // 滑块距上部距离
          newImageL: '', // 滑块距左边距离
          newImageW: '', // 滑块的宽
          newImageH: '', // 滑块的高
          disX: '', // 鼠标到按钮的水平距离
          disY: '', // 鼠标到按钮的垂直距离
          swiperL: '', // 滑块距离左侧距离
          changeBorderW: '', // 滑动的宽
          changeBorderH: '', // 滑动的高
          changeBorderB: '', // 滑动的背景色
          textO: 1, // 滑块提示信息的透明度
          gL: {
              imgReq: '', // 底图（二进制流）
              newImage: '', // 滑块（二进制流）
              Y: '' // Y轴值
          },
          loginBoll: true, // 防止重复点击登录
          saveBoll: true, // 防止重复验证
          verifyCodeKey: ''
      }
    },
    methods: {
      getQrCode () {
        this.$ajax.getQrCode().then((res) => {
          this.qrCode = `data:image/png;base64,${res.data.image}`
          this.loginId = res.data.loginId
          this.timer = setInterval(this.getLoginStatus.bind(this), 2000)
        })
      },
      orgApply () {
        this.$router.push({path: "/orgApply"})
      },
      orgLogon () {
          this.$router.push({path: "/organizeLogin"})
      },
      tabSelect (isExperts){
          this.isOrg=false
          this.isExp=false
          this.isExperts=isExperts;
      },
    //   机构登录
      loginIn (name) {
            this.loginError = ''
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let params = {
                        userName: this.loginUser.username,
                        password: this.loginUser.password
                    }
                    this.$ajax.organizationLogin(params).then((res) => {
                      if (res.code != 0) {
                            this.loginError = res.msg
                        } else {
                        window.localStorage['token'] = res.data
                        this.getUserInfo()
                        this.savePassword();
                        }
                    })
                }
            })
      },
    //   专家登录
      loginExp (name) {
            this.loginError = ''
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.codeBoll = true
                    this.getCaptcha()
                }
            })
      },
      // 获取拼图
      getCaptcha() {
          this.$ajax.getVerifyImg().then(res => {
              // console.log(res)
              if (res.code === '0') {
                  this.saveBoll = true
                  let data = res.data
                  this.verifyCodeKey = res.data.verifyCodeKey
                  // 还原滑块位置
                  this.textO = 1
                  this.swiperL = 0
                  this.newImageL = 0
                  this.changeBorderW = '20px'
                  this.changeBorderH = '20px'
                  this.changeBorderB = ''
                  // 设置底图及滑块
                  this.gL.imgReq = 'data:image/jpeg;base64,' + data.oriCopyImage // 底图
                  this.gL.newImage = 'data:image/jpeg;base64,' + data.newImage // 滑块图片
                  this.gL.Y = data.Y // 滑块距离上边的高度
                  // 设置拼图底图的宽高
                  this.imgBoxW = data.oirWidth + 'px'
                  this.imgBoxH = data.oriHeight + 'px'
                  // 设置滑块宽高及位置
                  this.newImageT = data.Y + 'px'
                  this.newImageL = 0
                  this.newImageW = data.newWidth
                  this.newImageH = data.newHeight
              }
          })
      },
      // 按下滑块
      swiperMove(e) {
          if (this.saveBoll) {
              this.saveBoll = false
              // 获取鼠标到按钮的距离
              this.disX = e.clientX - this.$refs.swiper.offsetLeft
              this.disY = e.clientY - this.$refs.swiper.offsetTop
              this.textO = 0
              let that = this
              this.$refs.box.onmousemove = function(ev) {
                  let oEvent = ev || event
                  that.boxMove(oEvent)
              }
          }
      },
      // 移动事件
      boxMove(e) {
          // 这里的e是以鼠标为参考
          let l = e.clientX - this.disX - this.$refs.handle.offsetLeft,
              winW = this.$refs.handle.offsetWidth - 38
          // 限制拖动范围只能在handle中
          if (l < 0) {
              l = 0
          }
          else if (l > winW) {
              l = winW
          }
          this.swiperL = l + 'px'
          this.newImageL = l + 'px'
          this.changeBorderW = l + 'px'
          this.changeBorderH = '36px'
          this.changeBorderB = '#409EFF'
      },
      // 移动停止事件
      boxUp() {
          let stopL = document.querySelector('.verify').offsetLeft, // 滑块距离左侧距离
              params = {
                  phoneNum: this.loginExpert.phone,
                  password: this.loginExpert.password,
                  stopL: stopL,
                  verifyCodeKey: this.verifyCodeKey
              }
          this.$refs.box.onmousemove = null
          this.$refs.box.onmouseup = null
          this.$ajax.usernameAndPasswordLogin(params).then((res) => {
              if (res.code != 0) {
                  this.saveBoll = true
                  // this.loginError = res.msg
                  this.$Message.error(res.msg)
                  this.getCaptcha()
              }
              else {
                  window.localStorage['token'] = res.data.token
                  if (res.data.status === 1) {
                      this.$router.push('/register?step=3')
                  } else if (res.data.status === 3) {
                      this.$router.push('/register?step=3&type=fail')
                  } else if (res.data.status === 2) {
                      this.getUserInfo()
                      this.savePassword();
                  } else {
                      this.$router.push('/setNickName')
                  }
              }
          })
      },
      getUserInfo () {
            this.$store.dispatch('getUserInfo').then((res) => {
                this.$router.push({
                    path: '/'
                })
            }, (err) => {
                console.log('获取用户信息失败')
            })
        },
        savePassword () {
            if(this.loginUser.isRemember) {
                var date=new Date();
                date.setTime(date.getTime()+(5*24*3600*1000));
                document.cookie=`username=${this.loginUser.username};expires=${date.toGMTString()}`;
                document.cookie=`password=${this.loginUser.password};expires=${date.toGMTString()}`;
            } else { // 删除
                var date=new Date();
                date.setTime(date.getTime()-(1*24*3600*1000));
                document.cookie=`username=;expires=${date.toGMTString()}`;
                document.cookie=`password=;expires=${date.toGMTString()}`;
            }
        },
        initPassword (){
            let cookie = document.cookie
            if (cookie&&cookie.length>0) {
                let cookies=cookie.split(";")
                for(let ob of cookies){
                    let valueOb=ob.split("=")
                    if(valueOb[0]){
                        this.loginUser[valueOb[0].trim()]=valueOb[1]
                    }
                    console.log(valueOb)
                }
                this.loginUser.isRemember=true;
            }
      },
      getLoginStatus () {
        this.$ajax.getLoginStatus({loginId: this.loginId}).then((res) => {
          let data = res.data
          if (data.type === 2) {
            // 用户扫描成功
            this.status = 'scanSuccess'
          }
          if (data.type === 3) {
            // 登陆成功
            // 获取token 存到 storage 里面
            clearInterval(this.timer)
            if (!this.once) {
              this.once = true
              this.status = 'loginSuccess'
              window.localStorage['token'] = data.data
              this.getUserInfo()
            }
          }
        })
      }
    },
    mounted () {
      window.localStorage['token'] = ''
    //  this.getQrCode()
      this.initPassword()
    //   new WxLogin({
    //     id: 'login-wx',
    //     appid: window.wtEnv.login_appid,
    //     scope: 'snsapi_login',
    //     redirect_uri: `${window.wtEnv.serverBaseUrl}/user/wxScanCode`,
    //     href:"https://wenqupc.oss-cn-beijing.aliyuncs.com/wechat.css"
    //   })

      // 判断是否有errMsg
      console.log(this.$route.params)
      let errMsg = this.$route.params.errMsg
      if (errMsg) {
        // 提示错误信息
        this.$Modal.error({
          title: '登录失败',
          content: errMsg
        })
      }
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Login.vue